import React, { useState } from "react";
import { connect } from "react-redux";
import "./floatingComponent.scss";
import { Link } from "react-router-dom";

const FloatingComponent = ({ token }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return (
    <div className="floating">
      {isMenuOpen ? (
        <div className="floating__menu">
          <Link to="/" className="floating__menu__button">
            Home
          </Link>
          {token === null ? (
            <>
              {/* Add floating button  */}
              <Link to="/login" className="floating__menu__button">
                Login
              </Link>
              <Link to="/register" className="floating__menu__button">
                Register
              </Link>
            </>
          ) : (
            <>
              <Link to="/explore" className="floating__menu__button">
                Explore
              </Link>
              <Link to="/profile/1" className="floating__menu__button">
                Profile
              </Link>
              <Link to="/logout" className="floating__menu__button">
                Logout
              </Link>
            </>
          )}
        </div>
      ) : null}
      <div
        className={`floating__icon ${isMenuOpen ? "closed" : null}`}
        onClick={() => setIsMenuOpen(!isMenuOpen)}>
        <div className="floating__icon__bar" />
        <div className="floating__icon__bar" />
        <div className="floating__icon__bar" />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    token: state.login.token,
  };
};

export default connect(mapStateToProps)(FloatingComponent);
